import React, { useEffect, useState } from "react"
import { MDBDataTable } from "mdbreact"
import { Row, Col, Card, CardBody, CardTitle, Button, } from "reactstrap"

import { connect } from "react-redux";
import Select from "react-select"

//Import Action to copy breadcrumb items from local state to redux state
import { setBreadcrumbItems } from "../../store/actions";

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import Loader from "components/Loader/Loader";
import { deleteCourse, fetchAllCourses, fetchSingleCourse, updateCourse } from "helpers/course_helper";
import { toast } from "react-toastify";
import { DOWNLOAD_ASSESSMENT_QUESTION_DEMO_FILE, FETCH_IMAGE } from "helpers/url_helper";
import { useParams } from "react-router-dom";
import { createModule, deleteModule, fetchAllModuleOfCourse, updateModule } from "helpers/module_helper";
import { generateDeletePresignedUrl, generatePreSignedUrl, generatePresignedUrlForAccess } from "helpers/Content_helper";
import axios from "axios";
import { createLesson, deleteLesson, updateLesson } from "helpers/lesson_helper";
import { v4 as uuidv4 } from 'uuid';


import { DataGrid } from '@mui/x-data-grid';
import Paper from '@mui/material/Paper';
import { HtmlEditor, Image, Inject, Link, PasteCleanup, QuickToolbar, RichTextEditorComponent, Toolbar } from "@syncfusion/ej2-react-richtexteditor";
import { createAssessment, deleteAssessment } from "helpers/assessment_helper";
import { fetchAllLevel } from "helpers/level_helper";
import { fetchAllSubCategoryBasedOnCategory } from "helpers/subCategory_helper";
import { fetchAllCategory } from "helpers/category_helper";
import { set } from "lodash";

const columns = [
    { field: 'id', headerName: 'ID', width: 70 },
    // { field: 'firstName', headerName: 'First name', width: 130 },
    // { field: 'lastName', headerName: 'Last name', width: 130 },
    {
        field: 'fullName',
        headerName: 'Full name',
        description: 'This column has a value getter and is not sortable.',
        sortable: false,
        width: 160,
        valueGetter: (value, row) => `${row.firstName || ''} ${row.lastName || ''}`,
    },
    {
        field: 'email',
        headerName: 'Email',
        type: 'text',
        width: 130,
    },
    {
        field: 'number',
        headerName: 'Number',
        type: 'number',
        width: 130,
    },

];

const rows = [
    { id: 1, lastName: 'Snow', firstName: 'Jon', age: 35, email: "snow@gmail.com", number: "1234567890" },
    { id: 2, lastName: 'Lannister', firstName: 'Cersei', age: 42, email: "lannister@gmail.com", number: "1234567890" },
    { id: 3, lastName: 'Lannister', firstName: 'Jaime', age: 45, email: "lani@gmail.com", number: "1234567890" },
    { id: 4, lastName: 'Stark', firstName: 'Arya', age: 16, email: "stark@gmail.com", number: "1234567890" },
    { id: 5, lastName: 'Targaryen', firstName: 'Daenerys', age: null, email: "targ@gmail.com", number: "1234567890" },
    { id: 6, lastName: 'Melisandre', firstName: null, age: 150, email: "meilisandre@gmail.com", number: "1234567890" },
    { id: 7, lastName: 'Clifford', firstName: 'Ferrara', age: 44, email: "clifford@gmail.com", number: "1234567890" },
    { id: 8, lastName: 'Frances', firstName: 'Rossini', age: 36, email: "frances@gmail.com", number: "1234567890" },
    { id: 9, lastName: 'Roxie', firstName: 'Harvey', age: 65, email: "roxie@gmail.com", number: "1234567890" },
];

const columns1 = [
    { field: 'id', headerName: 'ID', width: 70 },
    { field: 'name', headerName: 'Name', width: 130 },

    {
        field: 'email',
        headerName: 'Email',
        type: 'text',
        width: 130,
    },
    {
        field: 'number',
        headerName: 'Number',
        type: 'number',
        width: 130,
    },

];

const rows1 = [
    { id: 1, name: 'Rahul Sharma', age: 35, email: "snow@gmail.com", number: "1234567890" },
    { id: 2, name: 'Lannister', age: 42, email: "lannister@gmail.com", number: "1234567890" },
];

const paginationModel = { page: 0, pageSize: 5 };
const EditCourse = (props) => {
    document.title = "Question Bank | All Courses";
    const params = useParams();
    const [id, setId] = useState({});
    const [loader, setLoader] = useState(false);
    const [course, setCourse] = useState(null);
    const [addModuleModal, setAddModuleModal] = useState(false);
    const [editModuleModal, setEditModuleModal] = useState(false);
    const [deleteModuleConfirmModal, setDeleteModuleConfirmModal] = useState(false);
    const [moduleTitle, setModuleTitle] = useState("");
    const [moduleType, setModuleType] = useState("");
    const [moduleOrder, setModuleOrder] = useState("");
    const [spanDisplay, setSpanDisplay] = useState("none");
    const [editModule, setEditModule] = useState(false);
    const [moduleId, setModuleId] = useState("");
    const [modules, setModules] = useState([]);
    const [lessonTitle, setLessonTitle] = useState("");
    const [lessonContentType, setLessonContentType] = useState("");
    const [lessonUrl, setLessonUrl] = useState("");
    const [lessonDuration, setLessonDuration] = useState("");
    const [addLessonModal, setAddLessonModal] = useState(false);
    const [lessonContentFile, setLessonContentFile] = useState("");
    const [lessonContentName, setLessonContentName] = useState("");
    const [selectedModule, setSelectedModule] = useState(null);
    const [lessonOrQuizModal, setLessonOrQuizModal] = useState(false);
    const [editLesson, setEditLesson] = useState(false);
    const [deleteLessonConfirmModal, setDeleteLessonConfirmModal] = useState(false);
    const [deleteAssessmentConfirmModal, setDeleteAssessmentConfirmModal] = useState(false);
    const [createStudentSelectModal, setCreateStudentSelectModal] = useState(false);
    const [createSingleStudentModal, setCreateSingleStudentModal] = useState(false);
    const [createBulkStudentModal, setCreateBulkStudentModal] = useState(false);
    const [lessonId, setLessonId] = useState(false);
    const [assessmentId, setAssessmentId] = useState(false);
    const [lesson, setLesson] = useState(false);
    const [updateLessonModal, setUpdateLessonModal] = useState(false);
    const [addTrainerAccessModal, setAddTrainerAccessModal] = useState(false);
    const [selectedTab, setSelectedTab] = useState("modules");
    const [addAssessmentModal, setAddAssessmentModal] = useState(false);
    const [allLevels, setAllLevels] = useState([]);
    const [allCategories, setAllCategories] = useState([]);
    const [allSubCategories, setAllSubCategories] = useState([]);
    const [studentDetails, setStudentDetails] = useState({
        firstname: '',
        lastname: '',
        email: '',
        mobile: ''
    });
    const [assessment, setAssessment] = useState({
        title: "",
        duration: "",
        file: null,
        totalQuestions: "",
        minimumRightAnswer: "",
        warningCounts: "",

    });

    const breadcrumbItems = [
        { title: "Course", link: "#" },
        { title: "Edit Course", link: "#" },
    ]

    useEffect(() => {
        props.setBreadcrumbItems('Edit Course', breadcrumbItems)
    })
    useEffect(() => {
        const blurDiv = document.getElementById("blur");
        var width = window.innerWidth;
        if (width <= 994) {
            blurDiv.click()
        }
    }, [])

    const fetchCourse = async () => {
        try {
            setLoader(true);
            const data = await fetchSingleCourse(params.id);
            setLoader(false);

            if (data?.success) {
                let course = data?.result[0];

                // Generate pre-signed URLs for the course, with null checks
                course = await generatePresignedUrlsForCourse(course);
                console.log("after update feilds")
                console.log(course)
                // Set the updated course object with pre-signed URLs
                setCourse(course);
                fetchModules(course);
            } else {
                toast.error(data?.message);
            }
        } catch (error) {
            setLoader(false);
            toast.error(error?.response?.data?.message);
        }
    };


    const generatePresignedUrlsForCourse = async (course) => {
        const fieldsToUpdate = [
            { name: course?.thumbnailName, type: 'image', field: 'thumbnailNameUrl' },  // Update thumbnailName
            { name: course?.introVideo, type: 'Video', field: 'introVideoUrl' },        // Update introVideo
            { name: course?.certificate, type: 'Pdf', field: 'certificateUrl' }         // Update certificate
        ];

        const updatedFields = await Promise.all(
            fieldsToUpdate.map(async (field) => {
                // Check if field.name is not null or undefined
                if (field.name) {
                    try {
                        const response = await generatePresignedUrlForAccess({ name: field.name, type: field.type });

                        if (response.success) {
                            return { [field.field]: response.presignedUrl }; // Update the same field
                        } else {
                            console.error(`Error generating pre-signed URL for ${field.name}`);
                            return {};
                        }
                    } catch (error) {
                        console.error(`Error generating pre-signed URL for ${field.name}:`, error);
                        return {};
                    }
                }
                return {}; // Return empty if field.name is null or undefined
            })
        );

        // Merge the generated URLs back into the course object
        return {
            ...course,
            ...updatedFields.reduce((acc, field) => ({ ...acc, ...field }), {})
        };
    };



    const fetchModules = async (c) => {
        try {
            let courseDto = c;
            const data = await fetchAllModuleOfCourse(courseDto);
            if (data?.success) {
                setModules(data?.result);
            }

        } catch (error) {
            toast.error(error?.response?.data?.message);
        }
    }
    useEffect(() => {
        fetchCourse();
    }, [])

    const handleAddModule = async () => {
        try {
            if (!moduleTitle || !moduleType || !moduleOrder) {
                setSpanDisplay("inline")
            }
            else {



                setLoader(true);
                const data = await createModule({ title: moduleTitle, type: moduleType, moduleOrder, courseDto: course });
                setLoader(false);
                if (data?.success) {
                    toast.success(data?.message);
                    setAddModuleModal(false);
                    setModuleTitle("");
                    setModuleType("");
                    setModuleOrder("");
                    fetchModules(course);
                }
                else {
                    toast.error(data?.message);
                }


            }
        } catch (error) {
            setLoader(false);
            toast.error(error?.response?.data?.message);
        }
    }

    const handleDeleteModule = async () => {
        try {
            setLoader(true);
            const data = await deleteModule(moduleId);
            if (data?.success) {
                toast.success(data?.message);
                setDeleteModuleConfirmModal(false);
                setModuleId("");
                fetchModules(course);
            }
            else {
                toast.error(data?.message);
            }
        } catch (error) {
            setLoader(false);
            toast.error(error?.response?.data?.message)
        } finally {
            setLoader(false);
        }
    }
    const handleUpdateModuleClick = (data) => {
        setEditModuleModal(true);

        setModuleId(data?.id);
        setModuleOrder(data?.moduleOrder);
        setModuleTitle(data?.title);
        setModuleType(data?.type);
    }

    const handleDeleteModuleClick = (id) => {
        setDeleteModuleConfirmModal(true)
        setModuleId(id)
    }

    const handleUpdateModule = async () => {
        try {
            setLoader(true);
            const data = await updateModule({ id: moduleId, title: moduleTitle, type: moduleType, moduleOrder, courseDto: course });
            setLoader(false);
            if (data?.success) {
                toast.success(data?.message);
                setEditModuleModal(false);
                fetchModules(course);
            }
            else {
                toast.error(data?.message);
            }
        } catch (error) {
            setLoader(false);
            toast.error(error?.response?.data?.message)
        }
    }

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setLessonContentFile(file);
            setLessonContentName(file?.name); // Store the file name
        } else {
            setLessonContentFile(null);
            setLessonContentName('');
        }
    };



    const [progress, setProgress] = useState(1);
    const uploadData = (file, type, onProgress) => {
        console.log("Entering uploadData");
        console.log(file);
        return new Promise(async (resolve, reject) => {
            try {
                const name = uuidv4() + '.' + file.name.split('.').pop();
                // Request a pre-signed URL from the backend
                const result = await generatePreSignedUrl({ name, type });

                if (result?.success) {
                    const url = result?.presignedUrl; // Assuming your backend returns URL and headers for PUT request
                    console.log("Presigned URL: ", url);

                    // Upload the file to S3 using the pre-signed URL
                    await axios.put(url, file, {
                        headers: {
                            'Content-Type': file.type,
                        },
                        onUploadProgress: (progressEvent) => {
                            if (onProgress) {
                                const percentCompleted = Math.round(
                                    (progressEvent.loaded * 100) / progressEvent.total
                                );
                                onProgress(percentCompleted); // Update progress
                            }
                        }
                    });

                    resolve(name);
                } else {
                    reject(result?.message || 'Failed to get pre-signed URL.');
                }
            } catch (error) {
                console.error('Upload error:', error); // Log the error for debugging
                reject('Error uploading the file.');
            }
        });
    };

    const deleteData = (fileName, type) => {
        return new Promise(async (resolve, reject) => {
            try {
                // Request a pre-signed URL for deletion from the backend
                const result = await generateDeletePresignedUrl({ name: fileName, type });

                if (result?.success) {
                    const url = result?.presignedUrl; // Pre-signed URL for DELETE
                    console.log("Presigned URL for delete: ", url);

                    // Make the DELETE request using the pre-signed URL
                    await axios.delete(url);

                    resolve('File deleted successfully');
                } else {
                    reject(result?.message || 'Failed to get delete pre-signed URL.');
                }
            } catch (error) {
                console.error('Delete error:', error); // Log the error for debugging
                reject('Error deleting the file.');
            }
        });
    };


    const uploadDataForEdit = (file, type, onProgress) => {
        console.log("Entering uploadDataForEdit");
        return new Promise(async (resolve, reject) => {
            try {
                const name = uuidv4() + '.' + file.name.split('.').pop();
                // Request a pre-signed URL from the backend
                const result = await generatePreSignedUrl({ name, type });

                if (result?.success) {
                    const url = result?.presignedUrl; // Assuming your backend returns URL and headers for PUT request
                    console.log("Presigned URL: ", url);

                    // Upload the file to S3 using the pre-signed URL
                    await axios.put(url, file, {
                        headers: {
                            'Content-Type': file.type,
                        },
                        onUploadProgress: (progressEvent) => {
                            if (onProgress) {
                                const percentCompleted = Math.round(
                                    (progressEvent.loaded * 100) / progressEvent.total
                                );
                                onProgress(percentCompleted); // Update progress
                            }
                        }
                    });

                    resolve(name);
                } else {
                    reject(result?.message || 'Failed to get pre-signed URL.');
                }
            } catch (error) {
                console.error('Upload error:', error); // Log the error for debugging
                reject('Error uploading the file.');
            }
        });
    };


    function removeSpecificDivs(htmlString) {
        // Parse the HTML string into a new DOM document
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, 'text/html');

        // Selectors for the divs to remove based on class and id
        const selectorsToRemove = [
            'div.e-rte-content#defaultRTErte-view',
            'div.e-content.e-lib.e-keyboard#defaultRTE_rte-edit-view'
        ];

        // Iterate over selectors and remove the matching elements
        selectorsToRemove.forEach(selector => {
            const elements = doc.querySelectorAll(selector);
            elements.forEach(element => {
                // Instead of removing the element, we replace it with its content
                while (element.firstChild) {
                    element.parentNode.insertBefore(element.firstChild, element);
                }
                element.parentNode.removeChild(element);
            });
        });

        // Serialize the updated DOM back to a string
        // Inner HTML of the body will contain the expected output
        return doc.body.innerHTML;
    }

    const [lessonAddStatus, setLessonAddStatus] = useState(false);

    const handleAddLesson = async () => {
        setLessonAddStatus(true);
        const res = rteObjForLessonDescritption.getContent();
        let desc = res.outerHTML;

        desc = removeSpecificDivs(desc);
        let tempElement = document.createElement('div');
        tempElement.innerHTML = res.outerHTML;
        let textCont = tempElement.textContent || tempElement.innerText;

        try {
            if (!lessonTitle || !lessonContentType || !lessonDuration) {
                setSpanDisplay("inline")
            } else {
                setLoader(true);
                let url = "";
                if (lessonContentFile) {
                    setProgress(0);
                    const progressCallback = (progressValue) => {
                        setProgress(progressValue); // Update progress
                    };
                    url = await uploadData(lessonContentFile, lessonContentType.name, progressCallback);
                }
                const data = await createLesson({ title: lessonTitle, contentType: lessonContentType?.name, duration: lessonDuration, url: url, moduleDto: selectedModule, lessonDescription: desc, lessonDescriptionContent: textCont });

                if (data?.success) {
                    setAddLessonModal(false);
                    setLessonTitle("");
                    setLessonContentFile(null);
                    setLessonContentType(null);
                    setLessonDuration("");
                    setLessonUrl("");
                    toast.success(data?.message);
                    templateForLessonDescription = "";
                    fetchModules(course);
                }
                else {
                    toast.error(data?.message);
                }
            }

        } catch (error) {
            toast.error(error?.response?.data?.message);
        } finally {
            setLoader(false);
            setLessonAddStatus(false);
            setProgress(0);
        }
    }

    const handleUpdateLessonClick = (data) => {
        console.log(data)
        setUpdateLessonModal(true);

        setLessonId(data?.id);
        setLessonTitle(data?.title);
        setLessonContentType(lessonContentTypeData.find(item => item.name === data?.contentType));
        setLessonDuration(data?.duration);
        setLessonUrl(data?.url);

    }

    const handleUpdateLesson = async () => {

        try {
            setLoader(true);
            let url = lessonUrl;
            if (lessonContentFile) {
                setLessonAddStatus(true);
                setProgress(0);
                // Progress callback for upload
                const progressCallback = (progressValue) => {
                    setProgress(progressValue); // Update progress
                };

                // Delete the old file first
                await deleteData(url, lessonContentType.name);

                // Upload the new file with progress tracking
                url = await uploadDataForEdit(lessonContentFile, lessonContentType.name, progressCallback);
            }
            const data = await updateLesson({ id: lessonId, title: lessonTitle, contentType: lessonContentType?.name, duration: lessonDuration, url: url })
            // console.log("update lesson 3")
            if (data?.success) {
                setUpdateLessonModal(false);
                setLessonTitle("");
                setLessonContentFile(null);
                setLessonContentType(null);
                setLessonDuration("");
                setLessonUrl("");
                toast.success(data?.message);
                fetchModules(course);
            }
            else {
                toast.error(data?.message);
            }
        } catch (error) {
            toast.error(error?.response?.data?.message)
        } finally {
            setLoader(false);
            setLessonAddStatus(false);
            setProgress(0);
        }
    }

    const lessonContentTypeData = [
        { id: 1, name: "Video" },
        { id: 2, name: "Pdf" },
        { id: 3, name: "PPT" },
    ]
    const handleLessonContentTypeChange = selectedOption => {
        setLessonContentType(selectedOption);
    };

    const handleDeleteLessonClick = (id) => {
        setDeleteLessonConfirmModal(true)
        setLessonId(id)
    }

    const handleDeleteLesson = async () => {
        try {

            setDeleteLessonConfirmModal(false)
            setLoader(true);
            await deleteData(lesson?.url, lesson?.contentType);
            const data = await deleteLesson(lessonId);
            if (data?.success) {
                toast.success(data?.message);
                fetchModules(course);
            }
            else {
                toast.error(data?.message);
            }
        } catch (error) {
            setLoader(false);
            toast.error(error?.response?.data?.message)
        } finally {
            setLoader(false);
        }
    }

    const handleDeleteAssessment = async () => {
        try {

            setDeleteAssessmentConfirmModal(false)
            setLoader(true);
            const data = await deleteAssessment(assessmentId);
            if (data?.success) {
                toast.success(data?.message);
                fetchModules(course);
            }
            else {
                toast.error(data?.message);
            }
        } catch (error) {
            console.log("error", error);
            toast.error(error?.response?.data?.message || "Something went wrong");
        } finally {
            setLoader(false);
        }
    }

    const handleTest = () => {
        console.log("testing")
    }

    const handleCreateSingleStudent = () => {
        try {
            if (!studentDetails.firstname || studentDetails.lastname || studentDetails.email || studentDetails.mobile) {
                setSpanDisplay(true);
            }

        } catch (error) {
            console.log(error);
            toast.error(error?.response?.data?.message || "Something went wrong");
        } finally {
            setLoader(false);
            setSpanDisplay(false);
        }
    }

    const handleTrainerRowClick = (params) => {
        console.log(params.row);
        setAddTrainerAccessModal(true);
    };



    // Function for Assessment handling

    const handleAddAssessment = async () => {
        try {

            const formData = new FormData();
            formData.append("title", assessment.title);
            formData.append("duration", assessment.duration);
            formData.append("file", assessment.file); // Appending file
            formData.append("totalQuestions", assessment.totalQuestions);
            formData.append("minimumRightAnswer", assessment.minimumRightAnswer);
            formData.append("warningCounts", assessment.warningCounts);
            formData.append("moduleDto", JSON.stringify(selectedModule));

            const data = await createAssessment(formData);
            if (data?.success) {
                toast.success(data?.message);
                setAddAssessmentModal(false);
                setAssessment({
                    title: "",
                    duration: "",
                    file: null,
                    totalQuestions: "",
                    minimumRightAnswer: "",
                    warningCounts: "",

                });
                fetchModules(course);
            } else {
                toast.error(data?.message);
            }
        } catch (error) {
            toast.error(error?.response?.data?.message || "Something went wrong");
        } finally {
            setLoader(false);
        }
    }

    const handleAssessmentFileChange = (e) => {
        const file = e.target.files[0]; // get the selected file

        // Check if it's an Excel file
        const fileType = file?.type;
        if (fileType === "application/vnd.ms-excel" || fileType === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
            // Process the Excel file

            setAssessment({ ...assessment, file: file });  // Store the Excel file in the state
        } else {
            // Reject non-Excel files
            toast.warning("Please upload only Excel files (.xls, .xlsx)");
            setAssessment({ ...assessment, file: null }); // Clear any previously set file if it's not Excel
        }

    };

    const handleDownloadDemoAssessmentFile = async () => {
        try {
            setLoader(true);
            const response = await axios.get(DOWNLOAD_ASSESSMENT_QUESTION_DEMO_FILE, {
                responseType: 'blob' // Set response type to 'blob' to receive binary data
            });

            const blob = new Blob([response.data], { type: response.headers['content-type'] });

            // Create a URL for the blob data
            const url = window.URL.createObjectURL(blob);

            // Create a link element
            const link = document.createElement('a');
            link.href = url;

            // Specify the filename for the downloaded file
            link.setAttribute('download', 'question_file_format.xlsx');

            // Append the link to the body
            document.body.appendChild(link);

            // Click the link to trigger the download
            link.click();

            // Clean up: remove the link and revoke the URL object
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.log(error);
            toast.error(error?.response?.data?.message || "Something went wrong");

        } finally {
            setLoader(false);
        }
    }

    // ***** code for rich text editor textarea ****************


    const toolbarSettings = {
        items: ['Bold', 'Italic', 'Underline', 'StrikeThrough',
            'FontName', 'FontSize', 'FontColor', 'BackgroundColor',
            'LowerCase', 'UpperCase', '|',
            'Formats', 'Alignments', 'OrderedList', 'UnorderedList',
            'Outdent', 'Indent', '|',
            'CreateLink', 'Image', '|', 'ClearFormat', 'Print',
            'SourceCode', '|', 'Undo', 'Redo']
    };

    const quickToolbarSettings = {
        image: ['Replace', 'Align', 'Caption', 'Remove', 'InsertLink', 'OpenImageLink', '-', 'EditImageLink', 'RemoveImageLink', 'Display', 'AltText', 'Dimension'],
        link: ['Open', 'Edit', 'UnLink']
    };

    let rteObj;
    let rteObjForLessonDescritption;

    // set the value to Rich Text Editor
    // let template = `<div style="display:block;"><p style="margin-right:10px"></p></div>`;
    let template = "";
    let templateForLessonDescription = "";

    // Rich Text Editor items list
    let items = ['Bold', 'Italic', 'Underline', '|', 'Formats', 'Alignments', 'OrderedList',
        'UnorderedList', '|', 'CreateLink', 'Image', '|', 'SourceCode', '|', 'Undo', 'Redo'
    ];


    const htmlString = '<div class="e-rte-content" id="defaultRTErte-view" style="height: auto; margin-top: 0px; border-bottom: none;"><div class="e-content e-lib e-keyboard" id="defaultRTE_rte-edit-view" contenteditable="true" tabindex="0"><div style="display:block;"><p> </p><p style="margin-right: 10px; text-align: center;"><span style="font-size: 14pt;"><span style="font-family: &quot;Times New Roman&quot;, Times, serif;"><strong><span style="text-decoration: underline;"><span style="text-decoration: line-through;">dfkfdlfkdlkfdlfkdkfjdkf</span></span> fkdjfkdfjkdjfkdjfkoeiroeiroeiorieorioeiroeivm,cvmc,vmc,vmc,mv,cmv,c</strong></span></span></p><p style="margin-right:10px"> </p><ul><li style="margin-right:10px"><span style="font-family: Roboto, &quot;Segoe UI&quot;, GeezaPro, &quot;DejaVu Serif&quot;, &quot;sans-serif&quot;, -apple-system, BlinkMacSystemFont; background-color: unset; text-align: inherit;">dfkfdlfkdlkfdlfkdkfjdkf fkdjfkdfjkdjfkdjfkoeiroeiroeiorieorioeiroeivm,cvmc,vmc,vmc,mv,cmv,ewewew</span></li></ul><span style="font-family: Roboto, &quot;Segoe UI&quot;, GeezaPro, &quot;DejaVu Serif&quot;, &quot;sans-serif&quot;, -apple-system, BlinkMacSystemFont;">dfkfdlfkdlkfdlfkdkfjdkf fkdjfkdfjkdjfkdjfkoeiroeiroeiorieorioeiroeivm,cvmc,vmc,vmc,mv,cmv</span></div><ul><li style="display:block;"><span style="font-family: Roboto, &quot;Segoe UI&quot;, GeezaPro, &quot;DejaVu Serif&quot;, &quot;sans-serif&quot;, -apple-system, BlinkMacSystemFont;">dfkfdlfkdlkfdlfkdkfjdkf fkdjfkdfjkdjfkdjfkoeiroeiroeiorieorioeiroeivm,cvmc,vmc,vmc,mv,cmv,c klklk</span><p style="margin-right: 10px; cursor: auto;"><img src="blob:http://localhost:3000/5a96c08a-fe90-4ee0-9d74-83bb7376a00e" class="e-rte-image e-imginline" alt="Screenshot (648).png" width="126" height="auto" style="min-width: 20px; min-height: 0px;">  </p><ul><li style="list-style-type: none;"><ul><li style="list-style-type: none;"><ul><li><span style="font-family: Roboto, &quot;Segoe UI&quot;, GeezaPro, &quot;DejaVu Serif&quot;, &quot;sans-serif&quot;, -apple-system, BlinkMacSystemFont;">dfkfdlfkdlkfdlfkdkfjdkf fkdjfkdfjkdjfkdjfkoeiroeiroeiorieorioeiroeivm,cvmc,vmc,vmc,mv,cmv,c</span><span style="font-family: Roboto, &quot;Segoe UI&quot;, GeezaPro, &quot;DejaVu Serif&quot;, &quot;sans-serif&quot;, -apple-system, BlinkMacSystemFont; background-color: unset; text-align: inherit;"> </span></li></ul></li></ul></li></ul></li></ul></div></div>';

    const htmlContent = { __html: htmlString };




    const [editMode, setEditMode] = useState(false);
    const [courseData, setCourseData] = useState({
        title: course?.title || "",
        level: course?.levelDto?.name || "",
    });

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setCourse((prevCourse) => ({
            ...prevCourse,
            [name]: value,
        }));
    };


    const handleEdit = () => {
        setEditMode(true);
    };

    const handleSave = async () => {
        // Perform save logic here, e.g., send data to the backend
        try {
            setLoader(true);
            console.log("Saving data: ", course);

            let introVideoUrl2 = "";
            let certificateUrl2 = "";
            let thumbnailUrl2 = "";
            let localCourse = course;

            if (introVideoFile) {
                introVideoUrl2 = await uploadData(introVideoFile, 'Video');
                await deleteData(course?.introVideo, 'Video');
                localCourse.introVideo = introVideoUrl2;
                setIntroVideoFile(null);
                setIntroVideo("");

            }
            if (certificateFile) {
                certificateUrl2 = await uploadData(certificateFile, 'Pdf');
                await deleteData(course?.certificate, 'Pdf');
                localCourse.certificate = certificateUrl2;
                setCertificateFile(null);
                setCertificate("");
            }

            if (thumbnailFile) {
                console.log("thumbnail update hua");
                console.log("thumbnailFile", thumbnailFile);
                thumbnailUrl2 = await uploadData(thumbnailFile, 'image');
                await deleteData(course?.thumbnailName, 'image');
                localCourse.thumbnailName = thumbnailUrl2;
                setThumbnailFile(null);
                setThumbnail("");
            }



            const data = await updateCourse(localCourse);
            if (data?.success) {
                toast.success(data?.message);
                fetchCourse();
            } else {
                toast.error(data?.message);
            }
        } catch (error) {
            toast.error(error?.response?.data?.message || "Something went wrong.");
        } finally {
            setLoader(false);
        }

        setEditMode(false);
    };

    const handleCancel = () => {

        setEditMode(false);
    };

    const getAllLevel = async () => {
        try {
            setLoader(true);
            const result = await fetchAllLevel();
            if (result?.success) {
                setAllLevels(result?.result);
            }

        } catch (error) {
            toast.error(error?.response?.data?.message);
        } finally {
            setLoader(false);
        }
    }


    const fetchCategories = async () => {
        try {
            const data = await fetchAllCategory();

            if (data?.success) {
                setAllCategories(data?.result);
            }
            else {
                toast.error(data?.message);
            }
        } catch (error) {
            toast.error(error?.response?.data?.message);
        }
    }

    const fetchSubCategories = async (selectedValue) => {
        try {
            setLoader(true);
            const data = await fetchAllSubCategoryBasedOnCategory(selectedValue);
            setLoader(false);
            if (data?.success) {
                setAllSubCategories(data?.result);
            }
        } catch (error) {
            setLoader(false);
            toast.error(error?.response?.data?.message);
        }
    }

    useEffect(() => {
        fetchCategories();
        getAllLevel();
    }, []);

    const handleCategoryChange = (selectedValue) => {

        let a = course;
        a.categoryDto = selectedValue;

        setCourse({ ...course, categoryDto: selectedValue })
        setAllSubCategories([]);
        setCourse({ ...course, subCategoryDto: null })
        fetchSubCategories(selectedValue)
    }

    const handlePrerequisiteChange = (index, value) => {
        const newPrerequisites = [...course?.coursePrerequisits];
        newPrerequisites[index] = value;
        setCourse((prevCourse) => ({
            ...prevCourse,
            coursePrerequisits: newPrerequisites,
        }));
    };

    // Add a new empty prerequisite field directly to the course object
    const handleAddPrerequisite = () => {
        setCourse((prevCourse) => ({
            ...prevCourse,
            coursePrerequisits: [...prevCourse?.coursePrerequisits, ""],
        }));
    };

    const handleRemovePrerequisite = (index) => {
        const newPrerequisites = course.coursePrerequisits?.filter((_, i) => i !== index);
        setCourse((prevCourse) => ({
            ...prevCourse,
            coursePrerequisits: newPrerequisites,
        }));
    };

    // Handle changes in the student benefits directly in the course object
    const handleBenefitChange = (index, value) => {
        const newBenefits = [...course.studentBenefits];
        newBenefits[index] = value;
        setCourse((prevCourse) => ({
            ...prevCourse,
            studentBenefits: newBenefits,
        }));
    };

    // Add a new empty benefit field directly to the course object
    const handleAddBenefit = () => {
        setCourse((prevCourse) => ({
            ...prevCourse,
            studentBenefits: [...prevCourse.studentBenefits, ""],
        }));
    };

    // Remove a student benefit from the course object
    const handleRemoveBenefit = (index) => {
        const newBenefits = course.studentBenefits.filter((_, i) => i !== index);
        setCourse((prevCourse) => ({
            ...prevCourse,
            studentBenefits: newBenefits,
        }));
    };

    const courseTypeData = [
        { id: 1, name: "Private" },
        { id: 2, name: "Public" },
    ];
    const [courseType, setCourseType] = useState(course?.courseType);
    const handleCourseTypeChange = (selectedValue) => {
        setCourseType(selectedValue.name); // Store the name ("Private" or "Public") directly
        setCourse((prevCourse) => ({
            ...prevCourse,
            courseType: selectedValue.name, // Update courseType to the selected name
        }));
    };

    const reviewOptionData = [
        { id: 1, name: "On" },
        { id: 2, name: "Off" },
    ]
    const [reviewOption, setReviewOption] = useState(course?.reviewOption);

    const handleReviewOptionChange = (selectedValue) => {
        setReviewOption(selectedValue.name); // Store the name ("Private" or "Public") directly
        setCourse((prevCourse) => ({
            ...prevCourse,
            reviewOption: selectedValue.name, // Update courseType to the selected name
        }));
    };


    const [description, setDescription] = useState(course?.description);
    const handleEditorChange = () => {
        const rteValue = rteObj.getContent(); // Get content from the editor
        let desc = removeSpecificDivs(rteValue?.outerHTML); // Clean the content if necessary
        let tempElement = document?.createElement('div');
        tempElement.innerHTML = rteValue?.outerHTML;
        let textContent = tempElement.textContent || tempElement.innerText; // Get plain text

        setDescription(desc); // Update the description in state
        setCourse((prevCourse) => ({ ...prevCourse, description: desc })); // Update course with new description
        setCourse((prevCourse) => ({ ...prevCourse, textContent: textContent }));
    };



    function removeSpecificDivs(htmlString) {
        // Parse the HTML string into a new DOM document
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, 'text/html');

        // Selectors for the divs to remove based on class and id
        const selectorsToRemove = [
            'div.e-rte-content#defaultRTErte-view',
            'div.e-content.e-lib.e-keyboard#defaultRTE_rte-edit-view'
        ];

        // Iterate over selectors and remove the matching elements
        selectorsToRemove.forEach(selector => {
            const elements = doc.querySelectorAll(selector);
            elements.forEach(element => {
                // Instead of removing the element, we replace it with its content
                while (element.firstChild) {
                    element.parentNode.insertBefore(element.firstChild, element);
                }
                element.parentNode.removeChild(element);
            });
        });

        // Serialize the updated DOM back to a string
        // Inner HTML of the body will contain the expected output
        return doc.body.innerHTML;
    }


    const [thumbnail, setThumbnail] = useState(course?.thumbnailNameUrl || "");
    const [thumbnailFile, setThumbnailFile] = useState(course?.thumbnailNameUrl || "");

    // Handle file input change for thumbnail
    const handleThumbnailChange = (e) => {
        const file = e.target.files[0];
        setThumbnailFile(file);
        if (file) {
            const reader = new FileReader();
            reader.onload = (event) => {
                setThumbnail(event.target.result); // Set the selected thumbnail URL to display
            };
            reader.readAsDataURL(file);
        }
    };


    const [introVideo, setIntroVideo] = useState(course?.introVideoUrl || "");
    const [introVideoFile, setIntroVideoFile] = useState(course?.introVideoUrl || "");

    // Handle file input change for video
    const handleVideoChange = (e) => {
        const file = e.target.files[0];
        setIntroVideoFile(file);
        if (file) {
            const videoUrl = URL.createObjectURL(file);
            setIntroVideo(videoUrl); // Set the selected video URL to display

        }
    };


    const [certificate, setCertificate] = useState(course?.certificateUrl || "");
    const [certificateFile, setCertificateFile] = useState(course?.certificateUrl || "");

    // Handle file input change for certificate (PDF)
    const handleCertificateChange = (e) => {
        const file = e.target.files[0];
        setCertificateFile(file);
        if (file) {
            const certificateUrl = URL.createObjectURL(file);
            setCertificate(certificateUrl); // Set the selected certificate URL to display
        }
    };
    return (
        <React.Fragment>
            {loader ? (
                <Loader lessonAddStatus={lessonAddStatus} progress={progress} />
            ) : ("")}

            <Row>
                <Col className="col-12">
                    <Card>
                        <CardBody>
                            <CardTitle className="h4">Edit Courses </CardTitle>

                            <div className="d-flex mt-4 mb-5" style={{ borderBottom: "1px solid gray" }}>
                                {/* Info Tab */}
                                <div
                                    className="me-4"
                                    style={{
                                        borderBottom: selectedTab === "modules" ? "4px solid blue" : "none",
                                        cursor: "pointer"
                                    }}
                                    onClick={() => setSelectedTab("modules")}
                                >
                                    <h5>Modules</h5>
                                </div>

                                {/* Info Tab */}
                                <div
                                    className=""
                                    style={{
                                        borderBottom: selectedTab === "info" ? "4px solid blue" : "none",
                                        cursor: "pointer"
                                    }}
                                    onClick={() => setSelectedTab("info")}
                                >
                                    <h5>Info</h5>
                                </div>
                            </div>

                            {selectedTab === "modules" && (
                                <>
                                    <div className="row">
                                        <div className="col-md-12" >
                                            <h1 className="text-center">Modules</h1>
                                            <div className="d-flex justify-content-end">
                                                <Button type="button" color="primary" onClick={() => setEditModule(prevState => !prevState)} className="waves-effect waves-light align-self-end">{editModule ? "Done" : "Edit Modules"}</Button>
                                                <Button type="button" color="info" onClick={() => setAddModuleModal(true)} className="ms-2 waves-effect waves-light align-self-end">Add Modules</Button>

                                            </div>
                                            <div className="mt-5" >
                                                <div className="accordion" id="accordionExample">
                                                    {modules?.map((d, i) => (
                                                        <div className="accordion-item" key={i}>
                                                            <h2 className="accordion-header" id={`heading${i}`}>
                                                                <button
                                                                    className="accordion-button"
                                                                    type="button"
                                                                    data-bs-toggle="collapse"
                                                                    data-bs-target={`#collapse${i}`}
                                                                    aria-expanded={i === 0 ? "true" : "false"}
                                                                    aria-controls={`collapse${i}`}>
                                                                    {d.title} ({d.type})
                                                                    {editModule &&
                                                                        <>
                                                                            <button type='button' onClick={() => handleUpdateModuleClick(d)} className="warning" style={{ fontSize: "1.5rem", background: "none", border: "none", fontWeight: "bolder", }}> <i className="mdi mdi-pencil "></i></button>
                                                                            <button type='button' onClick={() => handleDeleteModuleClick(d?.id)} className="text-danger" style={{ fontSize: "1.5rem", background: "none", border: "none", fontWeight: "bolder", }}> <i className="mdi mdi-delete "></i></button>
                                                                        </>
                                                                    }
                                                                </button>
                                                            </h2>
                                                            <div
                                                                id={`collapse${i}`}
                                                                className={`accordion-collapse collapse ${i === 0 ? "show" : ""}`}
                                                                aria-labelledby={`heading${i}`}
                                                                data-bs-parent="#accordionExample">
                                                                <div className="accordion-body">
                                                                    <div className="d-flex justify-content-end">
                                                                        <button
                                                                            type="button"
                                                                            className="btn"
                                                                            onClick={() => { setEditLesson(prevState => !prevState); setSelectedModule(d); }}
                                                                            style={{ fontSize: "1rem" }}
                                                                        >

                                                                            {editLesson && selectedModule?.id === d?.id
                                                                                ?
                                                                                <i className="fa-solid fa-check"></i>
                                                                                :
                                                                                <i className="fa-solid fa-pen-to-square"></i>
                                                                            }
                                                                        </button>
                                                                        <button
                                                                            type="button"
                                                                            className="btn"
                                                                            onClick={() => { setLessonOrQuizModal(true); setSelectedModule(d); }}
                                                                            style={{ fontSize: "1rem" }}
                                                                        >
                                                                            <i className="fa-solid fa-circle-plus"></i>
                                                                        </button>
                                                                    </div>
                                                                    {d?.lessons?.map((lessonData, i) => (
                                                                        <>
                                                                            <div className="" style={{ borderBottom: "1px solid gray", borderRadius: "1rem", padding: ".5rem" }}>
                                                                                {lessonData.contentType == "Video" && (

                                                                                    <i className="fa-solid fa-video" style={{ fontSize: "1rem" }}></i>
                                                                                )}
                                                                                {lessonData.contentType == "Pdf" && (

                                                                                    <i className="fa-solid fa-file-pdf" style={{ fontSize: "1rem" }}></i>
                                                                                )}
                                                                                {lessonData.contentType == "PPT" && (

                                                                                    <i className="fa-solid fa-file-powerpoint" style={{ fontSize: "1rem" }}></i>
                                                                                )}

                                                                                {`  `}{lessonData?.title} ({lessonData?.duration} min)

                                                                                {selectedModule?.id === d?.id &&
                                                                                    <>

                                                                                        {editLesson &&
                                                                                            <>
                                                                                                <button
                                                                                                    type="button"
                                                                                                    className="btn"
                                                                                                    onClick={() => handleUpdateLessonClick(lessonData)}
                                                                                                // style={{ fontSize: "1rem" }}
                                                                                                >
                                                                                                    <i className="fa-solid fa-pen" ></i>
                                                                                                </button>
                                                                                                <button
                                                                                                    type="button"
                                                                                                    className="btn"
                                                                                                    onClick={() => { setDeleteLessonConfirmModal(true); setLessonId(lessonData?.id); setLesson(lessonData) }}
                                                                                                // style={{ fontSize: "1rem" }}
                                                                                                >
                                                                                                    <i className="fa-solid fa-trash" ></i>
                                                                                                </button>
                                                                                            </>
                                                                                        }
                                                                                    </>
                                                                                }
                                                                            </div >
                                                                        </>
                                                                    ))}

                                                                    {d?.assessment?.map((assessmentData, i) => (
                                                                        <>
                                                                            <div className="" style={{ borderBottom: "1px solid gray", borderRadius: "1rem", padding: ".5rem" }}>


                                                                                <i class="fa-solid fa-clipboard-check" style={{ fontSize: "1rem" }}></i>




                                                                                {`  `}{assessmentData?.title} ({assessmentData?.duration} min)

                                                                                {selectedModule?.id === d?.id &&
                                                                                    <>

                                                                                        {editLesson &&
                                                                                            <>

                                                                                                <button
                                                                                                    type="button"
                                                                                                    className="btn"
                                                                                                    onClick={() => { setDeleteAssessmentConfirmModal(true); setAssessmentId(assessmentData?.id); }}
                                                                                                // style={{ fontSize: "1rem" }}
                                                                                                >
                                                                                                    <i className="fa-solid fa-trash" ></i>
                                                                                                </button>
                                                                                            </>
                                                                                        }
                                                                                    </>
                                                                                }


                                                                            </div>
                                                                        </>
                                                                    ))}


                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}

                            {selectedTab === "info" && (
                                <>

                                    <div className="d-flex justify-content-end ">
                                        {editMode ? (
                                            <>
                                                <button
                                                    className="px-3 me-2"
                                                    style={{
                                                        cursor: "pointer",
                                                        border: "none",
                                                        backgroundColor: "#D4EDDA", // Green for saved, light blue for unsaved
                                                        color: "#155724", // Dark green for saved, purple for unsaved
                                                        fontSize: "1.2rem",
                                                        borderRadius: "10px",
                                                    }}
                                                    onClick={handleSave}
                                                >
                                                    <i className="mdi mdi-content-save"></i> Save
                                                </button>

                                                <button
                                                    className="px-3 me-2"
                                                    style={{
                                                        cursor: "pointer",
                                                        border: "none",
                                                        backgroundColor: "#F8D7DA", // Light red for cancelable, light blue for not cancelable
                                                        color: "#721C24", // Dark red for cancelable, purple for not cancelable
                                                        fontSize: "1.2rem",
                                                        borderRadius: "10px",
                                                    }}
                                                    onClick={handleCancel}
                                                >
                                                    <i className="mdi mdi-cancel"></i> Cancel
                                                </button>                                            </>
                                        ) : (
                                            <button className="px-3 me-2" style={{ cursor: "pointer", border: "none", backgroundColor: "#E5EBFF", color: "#6052E4", fontSize: "1.2rem", borderRadius: "10px" }} onClick={handleEdit} > <i className="mdi mdi-pencil "></i> Edit</button>
                                        )}
                                    </div>


                                    <div className="mt-4 ">
                                        <div className="row pb-2" style={{ border: '1px solid #ddd' }}>
                                            <div className="col-6">
                                                <h5>Title</h5>
                                                {editMode ? (
                                                    <input
                                                        type="text"
                                                        name="title"
                                                        value={course?.title}
                                                        onChange={handleInputChange}
                                                        className="form-control"
                                                    />
                                                ) : (
                                                    <p>{course?.title ? course?.title : "--"}</p>
                                                )}
                                            </div>
                                            <div className="col-6">
                                                <h5>Level</h5>
                                                {editMode ? (
                                                    <Select
                                                        value={course?.levelDto}
                                                        onChange={(selectedValue) => setCourse({ ...course, levelDto: selectedValue })}
                                                        options={allLevels}
                                                        getOptionLabel={(option) => option.name}
                                                        getOptionValue={(option) => option.id.toString()} // Ensure the ID is a string
                                                        classNamePrefix="select2-selection"
                                                        styles={{
                                                            menu: (provided) => ({
                                                                ...provided,
                                                                zIndex: 9999, // Set a high z-index value to avoid dropdown issues
                                                            }),
                                                            control: (provided) => ({
                                                                ...provided,
                                                                zIndex: 9999, // Ensure the control itself has a high z-index
                                                            }),
                                                        }}
                                                    />

                                                ) : (
                                                    <p>{course?.levelDto ? course?.levelDto?.name : "--"}</p>
                                                )}
                                            </div>

                                        </div>

                                        <div className="row pb-2" style={{ border: '1px solid #ddd' }}>
                                            <div className="col-6">
                                                <h5>Rating</h5>
                                                {editMode ? (
                                                    <input
                                                        type="text"
                                                        name="rating"
                                                        value={course?.rating}
                                                        onChange={handleInputChange}
                                                        className="form-control"
                                                    />
                                                ) : (
                                                    <p>{course?.rating ? course?.rating : "--"}</p>
                                                )}
                                            </div>
                                            <div className="col-6">
                                                <h5>Star</h5>
                                                {editMode ? (
                                                    <input
                                                        type="text"
                                                        name="star"
                                                        value={course?.star}
                                                        onChange={handleInputChange}
                                                        className="form-control"
                                                    />
                                                ) : (
                                                    <p>{course?.star ? course?.star : "--"}</p>
                                                )}
                                            </div>


                                        </div>

                                        <div className="row pb-2" style={style.border}>
                                            <div className="col-12">

                                                <h5>Short Description</h5>
                                                {editMode ? (
                                                    <input
                                                        type="text"
                                                        name="shortDesc"
                                                        value={course?.shortDesc}
                                                        onChange={handleInputChange}
                                                        className="form-control"
                                                    />
                                                ) : (
                                                    <p>{course?.shortDesc ? course?.shortDesc : "--"}</p>
                                                )}
                                            </div>
                                        </div>

                                        <div className="row pb-2" style={style.border}>
                                            <div className="col-12">
                                                <h5>Description</h5>
                                                {/* <p dangerouslySetInnerHTML={{ __html: course?.description ? course.description : "--" }}></p> */}

                                                {editMode ? (
                                                    // RichTextEditor in Edit Mode
                                                    <RichTextEditorComponent
                                                        id="defaultRTE"
                                                        ref={(scope) => { rteObj = scope; }}
                                                        valueTemplate={course?.description}
                                                        toolbarSettings={toolbarSettings}
                                                        change={handleEditorChange} // Automatically save on change
                                                    >
                                                        <Inject services={[HtmlEditor, Toolbar, Link, Image, QuickToolbar]} />
                                                    </RichTextEditorComponent>
                                                ) : (
                                                    // Display HTML content in View Mode
                                                    <p
                                                        dangerouslySetInnerHTML={{
                                                            __html: course?.description ? course.description : "--",
                                                        }}
                                                    ></p>
                                                )}
                                            </div>
                                        </div>

                                        <div className="row pb-2" style={style.border}>


                                            <div className="col-6">
                                                <h5>Language</h5>
                                                {editMode ? (
                                                    <input
                                                        type="text"
                                                        name="language"
                                                        value={course?.language}
                                                        onChange={handleInputChange}
                                                        className="form-control"
                                                    />
                                                ) : (
                                                    <p>{course?.language ? course?.language : "--"}</p>
                                                )}
                                            </div>
                                            <div className="col-6">
                                                <h5>Duration</h5>
                                                {editMode ? (
                                                    <input
                                                        type="text"
                                                        name="duration"
                                                        value={course?.duration}
                                                        onChange={handleInputChange}
                                                        className="form-control"
                                                    />
                                                ) : (
                                                    <p>{course?.duration ? course?.duration : "--"}</p>
                                                )}
                                            </div>
                                        </div>


                                        <div className="row pb-2" style={style.border}>
                                            <div className="col-6">
                                                <h5>Category</h5>
                                                {editMode ? (
                                                    <Select
                                                        value={course?.categoryDto}
                                                        onChange={handleCategoryChange}
                                                        options={allCategories}
                                                        getOptionLabel={(option) => option.name}
                                                        getOptionValue={(option) => option.id.toString()} // Ensure the ID is a string
                                                        classNamePrefix="select2-selection"
                                                        styles={{
                                                            menu: (provided) => ({
                                                                ...provided,
                                                                zIndex: 9999, // Set a high z-index value to avoid dropdown issues
                                                            }),
                                                            control: (provided) => ({
                                                                ...provided,
                                                                zIndex: 9999, // Ensure the control itself has a high z-index
                                                            }),
                                                        }}
                                                    />

                                                ) : (
                                                    <p>{course?.categoryDto ? course?.categoryDto?.name : "--"}</p>
                                                )}
                                            </div>
                                            <div className="col-6">
                                                <h5>Sub Category</h5>

                                                {editMode ? (
                                                    <Select
                                                        value={course?.subCategoryDto}
                                                        onChange={(selectedValue) => setCourse({ ...course, subCategoryDto: selectedValue })}
                                                        options={allSubCategories}
                                                        getOptionLabel={(option) => option.name}
                                                        getOptionValue={(option) => option.id.toString()} // Ensure the ID is a string
                                                        classNamePrefix="select2-selection"
                                                        styles={{
                                                            menu: (provided) => ({
                                                                ...provided,
                                                                zIndex: 9999, // Set a high z-index value to avoid dropdown issues
                                                            }),
                                                            control: (provided) => ({
                                                                ...provided,
                                                                zIndex: 9999, // Ensure the control itself has a high z-index
                                                            }),
                                                        }}
                                                    />

                                                ) : (
                                                    <p>{course?.subCategoryDto ? course?.subCategoryDto?.name : "--"}</p>
                                                )}
                                            </div>
                                        </div>


                                        <div className="row pb-2" style={style.border}>
                                            <div className="col-12">
                                                <h5>Thumbnail</h5>



                                                {editMode ? (
                                                    // File input for thumbnail in edit mode
                                                    <div>
                                                        {thumbnail ? (
                                                            <img
                                                                src={thumbnail}
                                                                alt="Selected Thumbnail"
                                                                style={{
                                                                    width: '100%',
                                                                    height: 'auto',
                                                                    maxWidth: '400px',
                                                                    marginBottom: '10px',
                                                                    border: "2px solid gray"
                                                                }}
                                                            />
                                                        ) : (
                                                            <p>--</p>
                                                        )}

                                                        {/* Input for selecting a new image */}
                                                        <input
                                                            type="file"
                                                            accept="image/*"
                                                            onChange={handleThumbnailChange}
                                                            className="form-control"
                                                        />
                                                    </div>
                                                ) : (
                                                    // Display current thumbnail in view mode
                                                    <>
                                                        {course?.thumbnailName ? (
                                                            <img
                                                                src={course.thumbnailNameUrl}
                                                                alt="Course Thumbnail"
                                                                style={{
                                                                    width: '100%',
                                                                    height: 'auto',
                                                                    maxWidth: '400px',
                                                                    marginBottom: '10px',
                                                                    border: "2px solid gray"
                                                                }}
                                                            />
                                                        ) : (
                                                            <p>--</p>
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                        </div>

                                        <div className="row pb-2" style={style.border}>
                                            <div className="col-6">

                                                <h5>Course Prerequisites</h5>
                                                {editMode ? (
                                                    <div>
                                                        {course.coursePrerequisits?.map((prerequisite, index) => (
                                                            <div key={index} className="mb-2 d-flex align-items-center">
                                                                <input
                                                                    id={`prerequisite-${index}`}
                                                                    type="text"
                                                                    className="form-control p-2"
                                                                    placeholder="Enter prerequisite"
                                                                    value={prerequisite || ""}
                                                                    onChange={(e) => handlePrerequisiteChange(index, e.target.value)}
                                                                    style={{ border: ".5px solid #bbb3b3" }}
                                                                />
                                                                <button
                                                                    type="button"
                                                                    className="btn ms-2"
                                                                    onClick={() => handleRemovePrerequisite(index)}
                                                                    style={{ fontSize: ".8rem" }}
                                                                >
                                                                    <i className="fa-solid fa-trash"></i>
                                                                </button>
                                                            </div>
                                                        ))}
                                                        <button
                                                            type="button"
                                                            className="btn"
                                                            onClick={handleAddPrerequisite}
                                                            style={{ fontSize: "1rem" }}
                                                        >
                                                            <i className="fa-solid fa-circle-plus"></i> Add Prerequisite
                                                        </button>
                                                    </div>
                                                ) : (
                                                    <ul>
                                                        {course.coursePrerequisits?.length > 0 ? (
                                                            course.coursePrerequisits?.map((prerequisite, index) => (
                                                                <li key={index}>{prerequisite}</li>
                                                            ))
                                                        ) : (
                                                            <p>--</p>
                                                        )}
                                                    </ul>
                                                )}
                                            </div>
                                            <div className="col-6">
                                                <h5>Student Benefits</h5>
                                                {editMode ? (
                                                    <div>
                                                        {course.studentBenefits.map((benefit, index) => (
                                                            <div key={index} className="mb-2 d-flex align-items-center">
                                                                <input
                                                                    id={`benefit-${index}`}
                                                                    type="text"
                                                                    className="form-control p-2"
                                                                    placeholder="Enter benefit"
                                                                    value={benefit || ""}
                                                                    onChange={(e) => handleBenefitChange(index, e.target.value)}
                                                                    style={{ border: ".5px solid #bbb3b3" }}
                                                                />
                                                                <button
                                                                    type="button"
                                                                    className="btn ms-2"
                                                                    onClick={() => handleRemoveBenefit(index)}
                                                                    style={{ fontSize: ".8rem" }}
                                                                >
                                                                    <i className="fa-solid fa-trash"></i>
                                                                </button>
                                                            </div>
                                                        ))}
                                                        <button
                                                            type="button"
                                                            className="btn"
                                                            onClick={handleAddBenefit}
                                                            style={{ fontSize: "1rem" }}
                                                        >
                                                            <i className="fa-solid fa-circle-plus"></i> Add Benefit
                                                        </button>
                                                    </div>
                                                ) : (
                                                    <ul>
                                                        {course.studentBenefits.length > 0 ? (
                                                            course.studentBenefits.map((benefit, index) => (
                                                                <li key={index}>{benefit}</li>
                                                            ))
                                                        ) : (
                                                            <p>--</p>
                                                        )}
                                                    </ul>
                                                )}
                                            </div>
                                        </div>

                                        <div className="row pb-2" style={style.border}>
                                            <div className="col-6">
                                                <h5>Creator Name</h5>
                                                {editMode ? (
                                                    <input
                                                        type="text"
                                                        name="creatorName"
                                                        value={course?.creatorName}
                                                        onChange={handleInputChange}
                                                        className="form-control"
                                                    />
                                                ) : (
                                                    <p>{course?.creatorName ? course?.creatorName : "--"}</p>
                                                )}
                                            </div>
                                            <div className="col-6">
                                                <h5>Course Type</h5>
                                                {editMode ? (
                                                    <Select
                                                        value={courseTypeData.find((option) => option.name === course.courseType)} // Find the selected option by name
                                                        onChange={handleCourseTypeChange}
                                                        options={courseTypeData}
                                                        getOptionLabel={(option) => option.name}
                                                        getOptionValue={(option) => option.id.toString()} // Convert to string if id is a number
                                                        classNamePrefix="select2-selection"
                                                    />
                                                ) : (
                                                    <p>{course?.courseType ? course?.courseType : "--"}</p>
                                                )}

                                            </div>
                                        </div>

                                        <div className="row pb-2" style={style.border}>

                                            <div className="col-6">
                                                <h5>Price</h5>
                                                {editMode ? (
                                                    <input
                                                        type="text"
                                                        name="price"
                                                        value={course?.price}
                                                        onChange={handleInputChange}
                                                        className="form-control"
                                                    />
                                                ) : (
                                                    <p>{course?.price ? course?.price : "--"}</p>
                                                )}
                                            </div>

                                            <div className="col-6">
                                                <h5>MRP</h5>
                                                {editMode ? (
                                                    <input
                                                        type="text"
                                                        name="mrp"
                                                        value={course?.mrp}
                                                        onChange={handleInputChange}
                                                        className="form-control"
                                                    />
                                                ) : (
                                                    <p>{course?.mrp ? course?.mrp : "--"}</p>
                                                )}
                                            </div>
                                        </div>
                                        <div className="row pb-2" style={style.border}>
                                            <div className="col-6">
                                                <h5>Review Option</h5>
                                                {editMode ? (
                                                    <Select
                                                        value={reviewOptionData.find((option) => option.name === course.reviewOption)} // Find the selected option by name
                                                        onChange={handleReviewOptionChange}
                                                        options={reviewOptionData}
                                                        getOptionLabel={(option) => option.name}
                                                        getOptionValue={(option) => option.id.toString()} // Convert to string if id is a number
                                                        classNamePrefix="select2-selection"
                                                    />
                                                ) : (
                                                    <p>{course?.reviewOption ? course?.reviewOption : "--"}</p>
                                                )}
                                            </div>

                                        </div>
                                        <div className="row pb-2" style={style.border}>
                                            <div className="col-6">
                                                <h5>Certificate</h5>

                                                {editMode ? (
                                                    // File input for certificate in edit mode
                                                    <div>
                                                        {certificate ? (
                                                            <iframe
                                                                src={certificate}
                                                                width="100%"
                                                                height="500px"
                                                                style={{ border: "none" }}
                                                                // sandbox="allow-scripts allow-same-origin" // Disable download and printing
                                                                title="Course Certificate"
                                                            />
                                                        ) : (
                                                            <p>--</p>
                                                        )}

                                                        {/* Input for selecting a new certificate PDF */}
                                                        <input
                                                            type="file"
                                                            accept="application/pdf"
                                                            onChange={handleCertificateChange}
                                                            className="form-control mt-2"
                                                        />
                                                    </div>
                                                ) : (
                                                    // Display current certificate in view mode
                                                    <>
                                                        {course?.certificate ? (
                                                            <iframe
                                                                src={course.certificateUrl}
                                                                width="100%"
                                                                height="500px"
                                                                style={{ border: "none" }}
                                                                title="Course Certificate"
                                                            />
                                                        ) : (
                                                            <p>--</p>
                                                        )}
                                                    </>
                                                )}
                                            </div>

                                            <div className="col-6">
                                                <h5>Intro Video</h5>


                                                {editMode ? (
                                                    // File input for intro video in edit mode
                                                    <div>
                                                        {introVideo ? (
                                                            <video
                                                                src={introVideo}
                                                                width="100%"
                                                                height="auto"
                                                                controls
                                                                preload="metadata"
                                                                controlsList="nodownload" // Disable download button
                                                                style={{ maxHeight: '500px' }}
                                                                onContextMenu={(e) => e.preventDefault()} // Disable right-click
                                                                title="Intro Video"
                                                            />
                                                        ) : (
                                                            <p>--</p>
                                                        )}

                                                        {/* Input for selecting a new video */}
                                                        <input
                                                            type="file"
                                                            accept="video/*"
                                                            onChange={handleVideoChange}
                                                            className="form-control"
                                                        />
                                                    </div>
                                                ) : (
                                                    // Display current video in view mode
                                                    <>
                                                        {course?.introVideo ? (
                                                            <video
                                                                src={course.introVideoUrl}
                                                                width="100%"
                                                                height="auto"
                                                                controls
                                                                preload="metadata"
                                                                controlsList="nodownload" // Disable download button
                                                                style={{ maxHeight: '500px' }}
                                                                onContextMenu={(e) => e.preventDefault()} // Disable right-click
                                                                title="Intro Video"
                                                            />
                                                        ) : (
                                                            <p>--</p>
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}
                        </CardBody>
                    </Card>
                </Col>
            </Row >
            {/* Modal for select Lesson or quiz  */}
            < Modal
                show={lessonOrQuizModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header >
                    <Modal.Title id="contained-modal-title-vcenter">
                        Select One
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>




                    <div className="d-flex flex-column justify-content-center align-items-center">
                        <Button type="button" color="info" onClick={() => { setAddLessonModal(true); setLessonOrQuizModal(false) }} className="waves-effect waves-light " style={{ width: "10rem " }}>Create Lesson</Button>{" "}
                        <Button type="button" color="info" onClick={() => { setAddAssessmentModal(true); setLessonOrQuizModal(false) }} className="waves-effect waves-light mt-2" style={{ width: "10rem " }}>Create Assessment</Button>{" "}
                    </div>



                </Modal.Body>
                <Modal.Footer>
                    <Button type="button" color="primary" onClick={() => setLessonOrQuizModal(false)} className="waves-effect waves-light">Close</Button>{" "}

                </Modal.Footer>
            </Modal >

            {/* Modal for create Module  */}

            < Modal
                show={addModuleModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header >
                    <Modal.Title id="contained-modal-title-vcenter">
                        Add Module
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>



                    <Row className="mb-3">
                        <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                        >
                            Title
                        </label>
                        <div className="col-md-10">
                            <input type="text"
                                className='form-control'
                                placeholder="Enter new Title"
                                value={moduleTitle}
                                maxLength="50"
                                onChange={(e) => setModuleTitle(e.target.value)} />
                            {!moduleTitle && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                        </div>
                    </Row>
                    <Row className="mb-3">
                        <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                        >
                            Module Type
                        </label>
                        <div className="col-md-10">
                            <input type="text"
                                className='form-control'
                                placeholder="Enter New Type"
                                value={moduleType}
                                maxLength="50"
                                onChange={(e) => setModuleType(e.target.value)} />
                            {!moduleType && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                        </div>

                    </Row>
                    <Row className="mb-3">
                        <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                        >
                            Module Order
                        </label>
                        <div className="col-md-10">
                            <input type="Number"
                                className='form-control'
                                placeholder="Enter Module Order"
                                value={moduleOrder}
                                maxLength="50"
                                onChange={(e) => setModuleOrder(e.target.value)}
                            />
                            {!moduleOrder && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                        </div>
                    </Row>




                </Modal.Body>
                <Modal.Footer>
                    <Button type="button" color="primary" onClick={() => setAddModuleModal(false)} className="waves-effect waves-light">Close</Button>{" "}
                    <Button type="button" color="success" onClick={handleAddModule} className="waves-effect waves-light">Create</Button>{" "}

                </Modal.Footer>
            </Modal >


            {/* Modal for create Lesson  */}
            < Modal
                show={addLessonModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header >
                    <Modal.Title id="contained-modal-title-vcenter">
                        Add Lesson
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>



                    <Row className="mb-3">
                        <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                        >
                            Title
                        </label>
                        <div className="col-md-10">
                            <input type="text"
                                className='form-control'
                                placeholder="Enter new Title"
                                value={lessonTitle}
                                maxLength="50"
                                onChange={(e) => setLessonTitle(e.target.value)} />
                            {!setLessonTitle && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                        </div>
                    </Row>
                    <Row className="mb-3">
                        <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                        >
                            Content Type
                        </label>
                        <div className="col-md-10">


                            <Select

                                value={lessonContentType}
                                onChange={handleLessonContentTypeChange}
                                options={lessonContentTypeData}
                                getOptionLabel={option => option.name}
                                getOptionValue={option => option.id.toString()} // Convert to string if classId is a number
                                classNamePrefix="select2-selection"
                            />
                            {!lessonContentType && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                        </div>

                    </Row>
                    <Row className="mb-3">
                        <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                        >
                            Duration
                        </label>
                        <div className="col-md-10">
                            <input type="Number"
                                className='form-control'
                                placeholder="Enter Lesson Duration in Minutes"
                                value={lessonDuration}
                                maxLength="50"
                                onChange={(e) => setLessonDuration(e.target.value)}
                            />
                            {!lessonDuration && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                        </div>
                    </Row>

                    <Row className="mb-3">
                        <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                        >
                            Select Content
                        </label>
                        <div className="col-md-10">


                            <input
                                type="file"
                                className='form-control'
                                placeholder="select the content"
                                accept="video/*,application/pdf,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation"
                                onChange={handleFileChange}
                            />
                            {!lessonContentFile && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                        </div>

                    </Row>

                    <Row className="mb-3">
                        <label
                            htmlFor="example-text-input"
                            className="col-md-12 col-form-label"
                        >
                            Enter Content Description
                        </label>
                        <div className="">

                            <RichTextEditorComponent id="defaultRTE" ref={(scope) => { rteObjForLessonDescritption = scope; }} valueTemplate={templateForLessonDescription} toolbarSettings={toolbarSettings} pasteCleanup={{
                                prompt: true,
                                plainText: false,
                                keepFormat: true
                            }}>
                                <Inject services={[HtmlEditor, Toolbar, Link, Image, QuickToolbar, PasteCleanup]} />
                            </RichTextEditorComponent>
                        </div>
                    </Row>






                </Modal.Body>
                <Modal.Footer>
                    <Button type="button" color="primary" onClick={() => setAddLessonModal(false)} className="waves-effect waves-light">Close</Button>{" "}
                    <Button type="button" color="success" onClick={handleAddLesson} className="waves-effect waves-light">Create</Button>{" "}

                </Modal.Footer>
            </Modal >

            {/* Modal for create Assessment  */}
            < Modal
                show={addAssessmentModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header >
                    <Modal.Title id="contained-modal-title-vcenter">
                        Add Assessment
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    <Row>
                        <div className="d-flex justify-content-end mb-3">
                            <button type="submit" className="btn btn-info w-md" onClick={handleDownloadDemoAssessmentFile}>Download Demo File</button>
                        </div>
                    </Row>


                    <Row className="mb-3">
                        <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                        >
                            Title
                        </label>
                        <div className="col-md-10">
                            <input type="text"
                                className='form-control'
                                placeholder="Enter new title"
                                value={assessment.title}
                                maxLength="50"
                                onChange={(e) => setAssessment({ ...assessment, title: e.target.value })} />
                            {!assessment.title && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                        </div>
                    </Row>

                    <Row className="mb-3">
                        <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                        >
                            Duration
                        </label>
                        <div className="col-md-10">
                            <input type="Number"
                                className='form-control'
                                placeholder="Enter assessment duration in minutes"
                                value={assessment.duration}
                                maxLength="50"
                                onChange={(e) => setAssessment({ ...assessment, duration: e.target.value })}
                            />
                            {!assessment.duration && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                        </div>
                    </Row>
                    <Row className="mb-3">
                        <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                        >
                            Total Questions
                        </label>
                        <div className="col-md-10">
                            <input type="Number"
                                className='form-control'
                                placeholder="Enter total questions"
                                value={assessment.totalQuestions}
                                maxLength="50"
                                onChange={(e) => setAssessment({ ...assessment, totalQuestions: e.target.value })}
                            />
                            {!assessment.totalQuestions && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                        </div>
                    </Row>

                    <Row className="mb-3">
                        <label
                            htmlFor="example-text-input"
                            className="col-md-3 col-form-label"
                        >
                            Minimum Qualify Question
                        </label>
                        <div className="col-md-9">
                            <input type="Number"
                                className='form-control'
                                placeholder="Enter minimum qualify qustions"
                                value={assessment.minimumRightAnswer}
                                maxLength="50"
                                onChange={(e) => setAssessment({ ...assessment, minimumRightAnswer: e.target.value })}
                            />
                            {!assessment.minimumRightAnswer && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                        </div>
                    </Row>
                    <Row className="mb-3">
                        <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                        >
                            Warning Count
                        </label>
                        <div className="col-md-10">
                            <input type="Number"
                                className='form-control'
                                placeholder="Enter total warnings"
                                value={assessment.warningCounts}
                                maxLength="50"
                                onChange={(e) => setAssessment({ ...assessment, warningCounts: e.target.value })}
                            />
                            {!assessment.warningCounts && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                        </div>
                    </Row>

                    <Row className="mb-3">
                        <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                        >
                            Select File
                        </label>


                        <div className="col-md-10">
                            <input
                                type="file"
                                accept='.xlsx'
                                name='xlsxFile'
                                id='xlsxFile'
                                placeholder='Upload a File'
                                className='form-control form-control-file'
                                data-buttonname="btn-secondary"
                                onChange={handleAssessmentFileChange} />
                            {!assessment.file && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}

                        </div>

                    </Row>



                </Modal.Body>
                <Modal.Footer>
                    <Button type="button" color="primary" onClick={() => setAddAssessmentModal(false)} className="waves-effect waves-light">Close</Button>{" "}
                    <Button type="button" color="success" onClick={handleAddAssessment} className="waves-effect waves-light">Create</Button>{" "}

                </Modal.Footer>
            </Modal >

            {/* Modal for Update Lesson  */}
            < Modal
                show={updateLessonModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header >
                    <Modal.Title id="contained-modal-title-vcenter">
                        Update Lesson
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>



                    <Row className="mb-3">
                        <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                        >
                            Title
                        </label>
                        <div className="col-md-10">
                            <input type="text"
                                className='form-control'
                                placeholder="Enter new Title"
                                value={lessonTitle}
                                maxLength="50"
                                onChange={(e) => setLessonTitle(e.target.value)} />
                            {!setLessonTitle && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                        </div>
                    </Row>
                    <Row className="mb-3">
                        <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                        >
                            Content Type
                        </label>
                        <div className="col-md-10">


                            <Select

                                value={lessonContentType}
                                onChange={handleLessonContentTypeChange}
                                options={lessonContentTypeData}
                                getOptionLabel={option => option.name}
                                getOptionValue={option => option.id.toString()} // Convert to string if classId is a number
                                classNamePrefix="select2-selection"
                            />
                            {!lessonContentType && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                        </div>

                    </Row>
                    <Row className="mb-3">
                        <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                        >
                            Duration
                        </label>
                        <div className="col-md-10">
                            <input type="Number"
                                className='form-control'
                                placeholder="Enter Lesson Duration in Minutes"
                                value={lessonDuration}
                                maxLength="50"
                                onChange={(e) => setLessonDuration(e.target.value)}
                            />
                            {!lessonDuration && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                        </div>
                    </Row>

                    <Row className="mb-3">
                        <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                        >
                            Select Content
                        </label>
                        <div className="col-md-10">


                            <input
                                type="file"
                                className='form-control'
                                placeholder="select the content"
                                accept="video/*,application/pdf,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation"
                                onChange={handleFileChange}
                            />
                            {!lessonContentFile && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                        </div>

                    </Row>






                </Modal.Body>
                <Modal.Footer>
                    <Button type="button" color="primary" onClick={() => setUpdateLessonModal(false)} className="waves-effect waves-light">Close</Button>{" "}
                    <Button type="button" color="success" onClick={handleUpdateLesson} className="waves-effect waves-light">Update</Button>{" "}

                </Modal.Footer>
            </Modal >

            {/* Modal for update module  */}

            < Modal
                show={editModuleModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header >
                    <Modal.Title id="contained-modal-title-vcenter">
                        Update Module
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>



                    <Row className="mb-3">
                        <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                        >
                            Title
                        </label>
                        <div className="col-md-10">
                            <input type="text"
                                className='form-control'
                                placeholder="Enter new Title"
                                value={moduleTitle}
                                maxLength="50"
                                onChange={(e) => setModuleTitle(e.target.value)} />
                            {!moduleTitle && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                        </div>
                    </Row>
                    <Row className="mb-3">
                        <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                        >
                            Module Type
                        </label>
                        <div className="col-md-10">
                            <input type="text"
                                className='form-control'
                                placeholder="Enter New Type"
                                value={moduleType}
                                maxLength="50"
                                onChange={(e) => setModuleType(e.target.value)} />
                            {!moduleType && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                        </div>

                    </Row>
                    <Row className="mb-3">
                        <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                        >
                            Module Order
                        </label>
                        <div className="col-md-10">
                            <input type="Number"
                                className='form-control'
                                placeholder="Enter Module Order"
                                value={moduleOrder}
                                maxLength="50"
                                onChange={(e) => setModuleOrder(e.target.value)}
                            />
                            {!moduleOrder && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                        </div>
                    </Row>




                </Modal.Body>
                <Modal.Footer>
                    <Button type="button" color="primary" onClick={() => setEditModuleModal(false)} className="waves-effect waves-light">Close</Button>{" "}
                    <Button type="button" color="success" onClick={handleUpdateModule} className="waves-effect waves-light">Update</Button>{" "}

                </Modal.Footer>
            </Modal >


            {/* Modal for delete confirm module  */}
            < Modal
                show={deleteModuleConfirmModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Body>

                    <h4>
                        Are you sure want to remove this Module.
                    </h4>


                </Modal.Body>
                <Modal.Footer>
                    <Button type="button" color="primary" onClick={() => { setDeleteModuleConfirmModal(false); }} className="waves-effect waves-light">No</Button>{" "}
                    <Button type="button" color="danger" onClick={handleDeleteModule} className="waves-effect waves-light">Yes</Button>{" "}

                </Modal.Footer>
            </Modal >

            {/* Modal for delete confirm Lesson  */}
            < Modal
                show={deleteLessonConfirmModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Body>

                    <h4>
                        Are you sure want to remove this Lesson.
                    </h4>


                </Modal.Body>
                <Modal.Footer>
                    <Button type="button" color="primary" onClick={() => { setDeleteLessonConfirmModal(false); }} className="waves-effect waves-light">No</Button>{" "}
                    <Button type="button" color="danger" onClick={handleDeleteLesson} className="waves-effect waves-light">Yes</Button>{" "}

                </Modal.Footer>
            </Modal >

            < Modal
                show={deleteAssessmentConfirmModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Body>

                    <h4>
                        Are you sure want to remove this Assessment.
                    </h4>


                </Modal.Body>
                <Modal.Footer>
                    <Button type="button" color="primary" onClick={() => { setDeleteAssessmentConfirmModal(false); }} className="waves-effect waves-light">No</Button>{" "}
                    <Button type="button" color="danger" onClick={handleDeleteAssessment} className="waves-effect waves-light">Yes</Button>{" "}

                </Modal.Footer>
            </Modal >

            {/* Modal for create student select  */}
            < Modal
                show={createStudentSelectModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Body>

                    <div className="d-flex justify-content-center">
                        <Button type="button" color="primary" onClick={() => { setCreateSingleStudentModal(true); setCreateStudentSelectModal(false) }} className="waves-effect waves-light align-self-end">Create Single Student</Button>
                        <Button type="button" color="info" onClick={() => setCreateBulkStudentModal(true)} className="ms-2 waves-effect waves-light align-self-end">Create Student in Bulk</Button>

                    </div>


                </Modal.Body>
                <Modal.Footer>
                    <Button type="button" color="primary" onClick={() => { setCreateStudentSelectModal(false); }} className="waves-effect waves-light">Close</Button>

                </Modal.Footer>
            </Modal >


            {/* Modal for create single student  */}
            < Modal
                show={createSingleStudentModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Body>

                    <Row className="mb-3">
                        <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                        >
                            First Name
                        </label>
                        <div className="col-md-10">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Enter First Name"
                                value={studentDetails.firstname} // bind to studentDetails.firstname
                                maxLength="50"
                                onChange={(e) => setStudentDetails(prevDetails => ({
                                    ...prevDetails,
                                    firstname: e.target.value // update the firstname field
                                }))}
                            />
                            {!studentDetails.firstname && <span style={{ color: "red", display: spanDisplay }}>This field is required</span>}
                        </div>
                    </Row>
                    <Row className="mb-3">
                        <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                        >
                            Last Name
                        </label>
                        <div className="col-md-10">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Last Name"
                                value={studentDetails.lastname}
                                maxLength="50"
                                onChange={(e) => setStudentDetails(prevDetails => ({
                                    ...prevDetails,
                                    lastname: e.target.value
                                }))}
                            />
                            {!studentDetails.lastname && <span style={{ color: "red", display: spanDisplay }}>This field is required</span>}
                        </div>
                    </Row>

                    <Row className="mb-3">
                        <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                        >
                            Email
                        </label>
                        <div className="col-md-10">
                            <input
                                type="email"
                                className="form-control"
                                placeholder="Enter Email"
                                value={studentDetails.email}
                                maxLength="100"
                                onChange={(e) => setStudentDetails(prevDetails => ({
                                    ...prevDetails,
                                    email: e.target.value
                                }))}
                            />
                            {!studentDetails.email && <span style={{ color: "red", display: spanDisplay }}>This field is required</span>}
                        </div>
                    </Row>

                    <Row className="mb-3">
                        <label
                            htmlFor="example-text-input"
                            className="col-md-2 col-form-label"
                        >
                            Mobile
                        </label>
                        <div className="col-md-10">
                            <input
                                type="tel"
                                className="form-control"
                                placeholder="Enter Mobile Number"
                                value={studentDetails.mobile}
                                maxLength="15"
                                onChange={(e) => setStudentDetails(prevDetails => ({
                                    ...prevDetails,
                                    mobile: e.target.value
                                }))}
                            />
                            {!studentDetails.mobile && <span style={{ color: "red", display: spanDisplay }}>This field is required</span>}
                        </div>
                    </Row>


                </Modal.Body>
                <Modal.Footer>
                    <Button type="button" color="primary" onClick={() => { setCreateSingleStudentModal(false); }} className="waves-effect waves-light">Close</Button>
                    <Button type="button" color="success" onClick={() => console.log(studentDetails)} className="waves-effect waves-light">Create</Button>

                </Modal.Footer>
            </Modal >

            {/* Modal for assing a course access to the trainer  */}
            < Modal
                show={addTrainerAccessModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header >
                    <Modal.Title id="contained-modal-title-vcenter">
                        Edit Trainer Access of this Course
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    <Row className="mb-3">

                        <div className="d-flex flex-wrap">
                            <div className="mb-3 col-md-4 col-12 d-flex align-items-center">
                                <label htmlFor="class_access" className="col-md-6 col-form-label">
                                    Create Test Assesment
                                </label>
                                <div className="mt-2">
                                    <input
                                        type="checkbox"
                                        id="class_access"
                                        name="class_access"
                                        value={1}
                                    />
                                </div>
                            </div>

                            <div className="mb-3 col-md-4 col-12 d-flex align-items-center">
                                <label htmlFor="class_access" className="col-md-6 col-form-label">
                                    Add Student
                                </label>
                                <div className="mt-2">
                                    <input
                                        type="checkbox"
                                        id="class_access"
                                        name="class_access"
                                        value={1}
                                    />
                                </div>
                            </div>
                        </div>

                    </Row>


                </Modal.Body>
                <Modal.Footer>
                    <Button type="button" color="primary" onClick={() => { setAddTrainerAccessModal(false); }} className="waves-effect waves-light">Close</Button>
                    <Button type="button" color="success" className="waves-effect waves-light">Save</Button>

                </Modal.Footer>
            </Modal >

        </React.Fragment >
    )
}


const style = {
    border: {
        borderBottom: "2px solid #ccc",
        borderRight: "2px solid #ccc",
        borderLeft: "2px solid #ccc",
        marginBottom: "10px"
    }
}
export default connect(null, { setBreadcrumbItems })(EditCourse);